module.exports = __webpack_public_path__ + "img/logo-sm.5b2e8cbc.png";